<!--
~ Copyright (c) 2023 Anvilor Solutions LLC - All Rights Reserved.
~
~ The information and source code contained herein is the exclusive property of
~ Anvilor Solutions LLC and may not be disclosed, examined, or reproduced in whole
~ or in part without the explicit written authorization from Anvilor Solutions LLC.
-->

@if (control) {
<div [nvlRuiControlContainer]="control.iid">
  <div #captchaWidgetOutlet></div>
</div>
}
